import { useRole } from "modules/roles/hooks/useRole";

export function useIsAdministrator() {
  const role = useRole();
  return role?.includes("ADMINISTRATOR");
}
